(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-and-image-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('image-slider')) {
    class ImageSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        this.currentEl = this.querySelector('[data-current]');
        this.index = 0;

        if (!this.track || this.slides.length < 2) return;

        this.onPrev = () => this.goTo(this.index - 1);
        this.onNext = () => this.goTo(this.index + 1);
        this.onKey = (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.goTo(this.index - 1); }
          if (e.key === 'ArrowRight') { e.preventDefault(); this.goTo(this.index + 1); }
        };
        this.onBlockSelect = (e) => {
          const i = this.slides.findIndex((s) => s.dataset.blockId === e.detail.blockId);
          if (i > -1) this.goTo(i);
        };

        this.prevBtn.addEventListener('click', this.onPrev);
        this.nextBtn.addEventListener('click', this.onNext);
        this.track.addEventListener('keydown', this.onKey);
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.setIndex(this.slides.indexOf(entry.target));
          });
        }, { root: this.track, threshold: 0.6 });
        this.slides.forEach((s) => this.observer.observe(s));

        this.setIndex(0);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      goTo(i) {
        const target = Math.max(0, Math.min(i, this.slides.length - 1));
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: this.slides[target].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
        this.setIndex(target);
      }

      setIndex(i) {
        if (i < 0) return;
        this.index = i;
        if (this.currentEl) this.currentEl.textContent = i + 1;
        if (this.prevBtn) this.prevBtn.disabled = i === 0;
        if (this.nextBtn) this.nextBtn.disabled = i === this.slides.length - 1;
      }
    }
    customElements.define('image-slider', ImageSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
